import AuthRepository from '@lib/api/repository/auth/auth.repository';
import { Account } from '@lib/types';

import { AccountDTO, createAccount } from '../accounts/models';
import { Requester } from '../clients';

type SessionResponse =
  | { account: AccountDTO; isAuthenticated: true }
  | { account: null; isAuthenticated: false };

class AuthAPI implements AuthRepository {
  async login(username: string, password: string): Promise<Account> {
    const response = await Requester.post<AccountDTO>('/auth/sign-in', {
      body: { email: username, password },
    });

    return createAccount(response.data);
  }

  async logout(): Promise<void> {
    await Requester.post('/auth/logout');
  }

  async findProfile(signal?: AbortSignal): Promise<Account | null> {
    const response = await Requester.get<SessionResponse>('/accounts/session', { signal });

    return response.data.isAuthenticated
      ? createAccount(response.data.account)
      : null;
  }

  async forgotPassword(email: string): Promise<void> {
    await Requester.post('/auth/forgot-password', { body: { email } });
  }

  async resetPassword(code: string, newPassword: string): Promise<void> {
    await Requester.patch(`/auth/reset-password`, {
      body: { code, newPassword },
    });
  }
}

export default AuthAPI;
